import { UserRoles } from 'clients/UserClient/types';
import { useContext, useMemo } from 'react';
import { AuthContext } from 'shared/legacy/contexts/AuthContext';
import { UserContext } from 'shared/legacy/contexts/UserContext/UserContext';

export type UseAuthHook = () => {
  isLoggedIn: boolean;
  isStaff: boolean;
  isAdmin: boolean;
  isLoading: boolean;
  activeToken: string | null;
};

export const useAuth: UseAuthHook = () => {
  const { isLoggedIn, currentUser, isFirstUserLoads, isInvalidToken } = useContext(UserContext);
  const { activeTokenType, isFirstTokenLoads, activeToken } = useContext(AuthContext);

  return useMemo(() => {
    return {
      activeToken: activeToken,
      isLoggedIn: isInvalidToken ? false : isLoggedIn,
      isStaff: Boolean(currentUser?.is_staff) || activeTokenType === 'impersonate',
      isAdmin: currentUser?.role === UserRoles.Admin,
      isLoading: (isFirstTokenLoads || isFirstUserLoads) && !isInvalidToken,
    };
  }, [activeTokenType, currentUser?.is_staff, isFirstTokenLoads, isLoggedIn, isFirstUserLoads, isInvalidToken]);
};

export default useAuth;
